var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 89,
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5001 81.5835H11.1249C9.07791 81.5835 7.41668 79.9221 7.41668 77.8752V11.1251C7.41668 9.07809 9.07809 7.41686 11.1249 7.41686H44.5001C46.5508 7.41686 48.2083 5.75929 48.2083 3.7086C48.2083 1.65792 46.5508 0 44.5001 0H11.1249C4.99137 0 0 4.99154 0 11.1251V77.8751C0 84.0086 4.99137 89 11.1249 89H44.5001C46.5508 89 48.2083 87.3424 48.2083 85.2917C48.2083 83.2411 46.5508 81.5835 44.5001 81.5835Z",
    fill: "#CACEAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1916 41.8597L65.6449 19.6097C64.1912 18.1708 61.8402 18.1895 60.4014 19.6468C58.9625 21.1042 58.9773 23.4515 60.4385 24.8904L76.5512 40.7917H33.375C31.3243 40.7917 29.6667 42.4492 29.6667 44.4999C29.6667 46.5506 31.3243 48.2083 33.375 48.2083H76.5512L60.4385 64.1096C58.9775 65.5485 58.9663 67.8958 60.4014 69.3532C61.1281 70.0874 62.0849 70.4582 63.0417 70.4582C63.9837 70.4582 64.9255 70.1022 65.6449 69.3901L88.1916 47.1401C88.8963 46.443 89.2967 45.4935 89.2967 44.4997C89.2967 43.5063 88.8999 42.5607 88.1916 41.8597Z",
    fill: "#CACEAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.61b625c1a3b681cc5d843efa21701b14.svg";
export { ForwardRef as ReactComponent };